module.exports = __webpack_public_path__ + "img/shuttle_service_and_courtesy_vehicles.3b2a3614.svg";